module.exports = "<div class=\"heading\" [ngStyle]=\"{'background-color':color}\">\n    <div class=\"icon\">\n      <img [src]=\"src\" height=\"{{height}}\">\n    </div>\n    <div class=\"descr\">\n      <strong class=\"title-instrument\">{{title}}</strong>\n      <p>{{info}}</p>\n    </div>\n  </div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/onboarding-hdr/onboarding-hdr.component.html
// module id = ../../../../../src/app/brds/widgets/onboarding-hdr/onboarding-hdr.component.html
// module chunks = 10